import { gql } from '@apollo/client';

export const UPDATE_WORKING_HOURS = gql`
  mutation UpdateWorkingHours($input: WorkingHoursInput) {
    updateWorkingHours(input: $input) {
      message
    }
  }
`;

export const UPDATE_PASSWORD = gql`
  mutation UpdatePassword($input: UpdatePasswordInput!) {
    updatePassword(input: $input) {
      message
    }
  }
`;

export const UPDATE_SETTINGS = gql`
  mutation UpdateSettings($input: UpdateSettingsInput) {
    updateSettings(input: $input) {
      message
    }
  }
`;

export const CREATE_PAYMENT_ACCOUNT = gql`
  mutation CreatePaymentAccount($input: PaymentAccountInput!) {
    createPaymentAccount(input: $input) {
      message
    }
  }
`;

export const UPDATE_PAYMENT_ACCOUNT = gql`
  mutation UpdatePaymentAccount($id: ID!, $input: PaymentAccountInput!) {
    updatePaymentAccount(id: $id, input: $input) {
      message
    }
  }
`;

export const SEND_CONTACT_US = gql`
  mutation SendContactUsEmail($input: ContactUsInput) {
    sendContactUsEmail(input: $input) {
      message
    }
  }
`;
